import {QueryClient} from '@tanstack/react-query';

// Single shared QueryClient instance, exported so auth-boundary code
// (login/OTP-verification success, logout) can clear cached query data
// without going through React context.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
